import React from "react";
import ListTemplatesManager from "./views/ListTemplatesManager";

export default function ListTemplatesApp() {
  return <ListTemplatesManager />;
}
